<template>
	<div class="credit-request">
		<Modal
			:title="title"
			:closeOnOverlayClick="false"
			:visible="visible"
			@close="onCancel"
			class="credit-request-modal"
		>
			<template v-slot:body>
				<div>
					<p>Select an option to proceed with the credit request.</p>
				</div>

				<div class="credit-request-modal__buttons">
					<CardButton
						iconClassName="icon-credit-report"
						label="Credit Report"
						subText="Get a credit report from major credit bureaus."
						@click="handleCreditReportClick"
						class="credit-request-modal__card-buttons"
					></CardButton>

					<CardButton
						iconClassName="icon-forms"
						label="Credit Application"
						subText="Fill out a credit application to explore financing options."
						@click="handleCreditApplicationClick"
						class="credit-request-modal__card-buttons"
					></CardButton>
				</div>
				<Hyperlink
					v-if="recentCreditReportResult.id != 0"
					href=""
					@click="fetchSignedIframeUrl"
				>
					Last Report {{ dateSubmitted }}
				</Hyperlink>
			</template>
		</Modal>
		<template>
			<Toast
				:visible="showToast"
				:dismissibleTime="10"
				:state="toastState"
				:iconClassName="toastIcon"
				@removed="onToastRemoved"
				:siteLevel="true"
			>
				<template v-slot:bodyMsg>
					{{ toastText }}
				</template>
			</Toast>
		</template>
	</div>
</template>

<script>
import Modal from '@/components/shells/modal/modal.vue';
import { mapGetters, mapActions } from 'vuex';
import viewMixin from '@/mixins/view-mixin';
import CardButton from '@/components/shells/card/card-button.vue';
import Hyperlink from '@/components/typography/hyperlink/hyperlink.vue';
import messageHandlerMixin from '@/mixins/message-handler-mixin';
import pageMixin from '@/mixins/page-mixin';
import Toast from '@/components/notifications/toast/toast.vue';

export default {
	name: 'CreditRequestModal',
	mixins: [viewMixin, messageHandlerMixin, pageMixin],
	components: {
		Modal,
		CardButton,
		Hyperlink,
		Toast
	},
	data() {
		return {
			title: 'undefined',
			showToast: false,
			toastState: 'positive',
			toastIcon: '',
			toastText: ''
		};
	},
	props: {
		id: {
			type: Number,
			required: true
		},
		visible: {
			type: Boolean,
			default: true
		},
		isProspect: {
			type: Boolean,
			default: false
		}
	},
	async created() {
		this.title = 'Credit Request';
		this.hidePageLoader();

		let searchType = 'S';
		if (this.isProspect === true) {
			searchType = 'P';
		}

		await this.getRecentCreditReportAction({
			companyId: this.companyId,
			searchType: searchType,
			searchId: this.id
		});
	},
	watch: {},
	computed: {
		...mapGetters('deal', [
			'recentCreditReportResult',
			'signedIframeUrlResult'
		]),
		dateSubmitted() {
			return this.submittedDateFormatter(
				this.recentCreditReportResult.submittedDate
			);
		}
	},
	methods: {
		...mapActions('deal', [
			'getRecentCreditReportAction',
			'getSignedIframeUrlAction'
		]),

		handleCreditReportClick() {
			let query = {
				id: this.id,
				deal: this.deal,
				dealType: this.dealType,
				isProspect: this.isProspect
			};

			this.$router.push({
				name: 'CreditReportImport',
				query: query
			});
		},
		handleCreditApplicationClick() {
			let query = {
				id: this.id,
				deal: this.deal,
				dealType: this.dealType,
				isProspect: this.isProspect
			};

			this.$router.push({
				name: 'CreditApplicationImport',
				query: query
			});
		},
		onCancel() {
			this.sendCloseMessageToAccess();
			this.visible = false;
		},
		sendCloseMessageToAccess() {
			this.postCloseMessageToAccess();
		},
		submittedDateFormatter(date) {
			return date.split(' ')[0];
		},
		async fetchSignedIframeUrl() {
			let searchType = 'S';
			if (this.isProspect === true) {
				searchType = 'P';
			}
			await this.getSignedIframeUrlAction({
				companyId: this.companyId,
				searchType: searchType,
				searchId: this.id
			});

			if (this.signedIframeUrlResult.startsWith('ERROR:')) {
				this.toastState = 'negative';
				this.toastIcon = 'icon-warning';
				this.toastText = this.signedIframeUrlResult.replace(
					/^ERROR:\s*/,
					''
				);
				this.showToast = true;
				return;
			}

			window.open(this.signedIframeUrlResult, '_blank');
		},
		onToastRemoved() {
			this.showToast = false;
		}
	}
};
</script>

<style lang="scss" scoped>
@include scrollbar('borderless');

.credit-request-modal {
	&__buttons {
		display: flex;
		justify-content: center;
		gap: $gutter-xl;
		margin-top: $gutter-xl;
		margin-bottom: $gutter-lg;
	}

	&__card-buttons {
		max-width: 285px;
	}
}
</style>
